module.exports = __webpack_public_path__ + "static/media/skip-forward.6cd0a91c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/skip-forward.svg
// module id = 435
// module chunks = 0